module.exports = __webpack_public_path__ + "static/media/DAK-Profile-Pic.e959df3a.png";